import api from "../index";

export const GetAllfaqApi = (params) => api.get(`faq/get-all-faq?${params}`);
export const FaqStatusApi = (data) => api.put('faq/active-inactive-faq', data);
export const GetAllfaqByIdApi = (FaqId) => api.get(`faq/get-faq-details-byid/${FaqId}`);
export const DeleteFaqApi = (faqId) => api.delete(`faq/delete-faq/${faqId}`);
export const AddUpdateFaqApi = (data, headers) => api.post('faq/add-update-faqs', data, headers);
export const GetAllContriensApi = () => api.get('faq/get-all-faqs-categories');